import { Button } from '@checkatrade/web-ui';

type Props = {
  disablePrimary?: boolean;
  primaryLabel: string;
  secondaryLabel?: string;
  showSecondary?: boolean;
  handlePrimaryButton: () => void;
  handleSecondaryButton?: () => void;
};

const Footer = ({
  disablePrimary,
  primaryLabel,
  secondaryLabel = '',
  showSecondary,
  handlePrimaryButton,
  handleSecondaryButton,
}: Props) => {
  const onClickPrimary = () => {
    handlePrimaryButton();
  };

  const onClickSecondary = () => {
    handleSecondaryButton?.();
  };

  return (
    <div className="sticky bottom-0 bg-white pt-1 sm:sticky sm:w-full">
      <Button
        disabled={disablePrimary}
        className="w-full"
        onClick={onClickPrimary}
        name={primaryLabel}
      >
        {primaryLabel}
      </Button>
      {showSecondary && (
        <Button
          variant="outline"
          className="mt-2 w-full"
          onClick={onClickSecondary}
          name={secondaryLabel}
        >
          {secondaryLabel}
        </Button>
      )}
    </div>
  );
};

export default Footer;
